<template>
    <CHeader fixed with-subheader light>
        <CToggler
            in-header
            class="ml-3 d-lg-none"
            @click="$store.commit('toggleSidebarMobile')"
        />
        <CToggler
            in-header
            class="ml-3 d-md-down-none"
            @click="$store.commit('toggleSidebarDesktop')"
        />
        <CHeaderBrand class="mx-auto d-lg-none" to="/">
            <img src="/img/brand/backend-logo.png" class="logo">
        </CHeaderBrand>

        <CMenu/>

        <CHeaderNav class="mr-4">
            <CDropdown
                inNav
                class="c-header-nav-items"
                placement="bottom-end"
                add-menu-classes="pt-0"
            >
                <template #toggler>
                    <CHeaderNavLink>
                        <CIcon name="cil-bell"/>
                        <CBadge color="warning" class="ml-2 position-static">{{numNotifications}}</CBadge>
                    </CHeaderNavLink>
                </template>
                <CDropdownHeader tag="div" class="text-center" color="light">
                    <strong>Notifications</strong>
                </CDropdownHeader>
                <CDropdownItem v-for="(item, index) in notifications" :key="index" @click="goTo(item.id)">
                    <template>
                        <CHeaderNavLink>
                            <div>
                                <CRow>
                                    <CCol col="12" lg="12">
                                        {{item.name}}
                                    </CCol>
                                    <CCol col="12" lg="12">
                                        Overdue <span style="color:red">Credit</span>
                                          – {{item.total}} – {{item.order_dat}}
                                    </CCol>
                                    <CCol col="12" lg="12">
                                        {{item.phone}}
                                    </CCol>
                                    <CCol col="12" lg="12">
                                        {{item.phone2}}
                                    </CCol>
                                </CRow>
                            </div>
                        </CHeaderNavLink>
                    </template>
                </CDropdownItem>
            </CDropdown>
            <TheHeaderDropdownAccnt/>
        </CHeaderNav>
        <CSubheader class="px-3">
            <CBreadcrumbRouter class="border-0 mb-0"/>
        </CSubheader>
    </CHeader>
</template>

<script>
import CMenu from './Menu'
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'

export default {
    name: 'TheHeader',
    props: ['notifications', 'numNotifications'],
    components: {
        TheHeaderDropdownAccnt,
        CMenu
    },
    methods: {
        goTo(id) {
            this.$router.replace({ path: `/clients/${id}` });
        }
    },
}
</script>

<style lang="scss" scoped>
.logo {
    width: 200px;
}
</style>
